import React from "react";
import { Descriptions as AntdDescriptions } from "antd";
import type { DescriptionsProps as AntdDescriptionsProps } from "antd";

const { Item: AntdDescriptionsItem } = AntdDescriptions;

export type DescriptionsProps = AntdDescriptionsProps;

/**
 * Descriptions component - display grouped information
 */
const Descriptions: React.FC<DescriptionsProps> & {
  Item: typeof AntdDescriptionsItem;
} = (props) => {
  return <AntdDescriptions {...props} />;
};

// Attach static properties
Descriptions.Item = AntdDescriptionsItem;

export default Descriptions;
